import { render, staticRenderFns } from "./improveInfo.vue?vue&type=template&id=b1508b2a&scoped=true&"
import script from "./improveInfo.vue?vue&type=script&lang=js&"
export * from "./improveInfo.vue?vue&type=script&lang=js&"
import style0 from "./improveInfo.vue?vue&type=style&index=0&id=b1508b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1508b2a",
  null
  
)

export default component.exports